import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { formateNumber } from 'shared/helpers';

// import { getTimeFromUTCToTimezone } from 'shared/utils/getTimeFromUTCToTimezone';

dayjs.extend(customParseFormat);

export class CbuPaymentsConverter {
  convertRequests(data) {
    const items = data.items.map(item => ({
      id: item.id,
      // 0 - deposit, 1 - withdrawal
      type: item.type === 1 ? 'withdrawal' : 'deposit',
      comment: item.comment,
      createdAt: item.created_at,
      username: item.username,
      amount: formateNumber(item.amount),
      cbu: item.cbu,
      name: item.name,
      bonusPercent: item.bonus_percent,
      bank: item.bank,
      phoneNumber: item.phone_number,
      promoCodePercent: item.promo_code_percent,
    }));

    return {
      items,
      count: data.count,
    };
  }
}
